<template>
  <HomePage
    :articles="articles"
    :logos="logos"
  />
</template>

<script setup>
const { $cmsApi } = useNuxtApp();

const { data } = await useAsyncData(async () => {
  try {
    const articles = await $cmsApi.get('/articles/homepage');

    const logoData = await $cmsApi.get('/homepage/logo-section-logos');
    const logos = {
      firstSectionLogos: logoData?.first_section_logos || [],
      secondSectionLogos: logoData?.second_section_logos || [],
      logos: logoData?.logos || [],
    };

    return {
      articles,
      logos,
    };
  } catch (error) {
    console.error('Error fetching data:', error);
  }
});

const articles = data.value?.articles || [];
const logos = data.value?.logos || {};
</script>
